interface KnowledgeDatainterface {
    name: string;
    percent: number;
}

const KnowledgeData: KnowledgeDatainterface[] = [
    {
        name: "Knowledge-1",
        percent: 0,
    }, {
        name: "Knowledge-2",
        percent: 20,
    }, {
        name: "Knowledge-3",
        percent: 40,
    }, {
        name: "Knowledge-4",
        percent: 60,
    }, {
        name: "Knowledge-5",
        percent: 80,
    }, {
        name: "Knowledge-6",
        percent: 100,
    }
];

export { KnowledgeData };
